var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpwardArrowRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83875 23.4796L7.59875 23.4796L7.59875 4.91961L2.31875 10.1996L0.718751 8.59961L8.71875 0.59961L16.7188 8.59961L15.1188 10.1996L9.83875 4.91961L9.83875 23.4796Z",
    fill: "#E72E50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpwardArrowRed);
export default __webpack_public_path__ + "static/media/upward_arrow_red.a0f9e3fb080f6de07ac55b50d2552a3a.svg";
export { ForwardRef as ReactComponent };